import React, { useState } from "react";
import axios from "axios";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!form.current || !form.next) { toast.error("Fill in both passwords"); return; }
    if (form.next.length < 6) { toast.error("New password must be at least 6 characters"); return; }
    if (form.next !== form.confirm) { toast.error("New passwords don't match"); return; }
    setSaving(true);
    try {
      await axios.post("/auth/change-password", {
        current_password: form.current,
        new_password: form.next,
      });
      toast.success("Password updated");
      setForm({ current: "", next: "", confirm: "" });
      onOpenChange(false);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed to change password");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Change password</DialogTitle>
          <DialogDescription>Enter your current password, then choose a new one (at least 6 characters).</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label htmlFor="cp-current">Current password</Label>
            <Input id="cp-current" type="password" value={form.current}
              onChange={e => setForm(f => ({ ...f, current: e.target.value }))}
              autoFocus data-testid="input-current-password" />
          </div>
          <div>
            <Label htmlFor="cp-next">New password</Label>
            <Input id="cp-next" type="password" value={form.next}
              onChange={e => setForm(f => ({ ...f, next: e.target.value }))}
              data-testid="input-new-password" />
          </div>
          <div>
            <Label htmlFor="cp-confirm">Confirm new password</Label>
            <Input id="cp-confirm" type="password" value={form.confirm}
              onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))}
              onKeyDown={e => { if (e.key === "Enter") submit(); }}
              data-testid="input-confirm-password" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={submit} disabled={saving} data-testid="btn-submit-change-password">
            {saving ? "Saving…" : "Update password"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
